import type { SVGProps } from 'react';

/**
 * The dismiss mark, as the design draws it: two thin strokes with rounded ends,
 * inset half a box. The inset is deliberate — the mark carries its own padding,
 * so it centres inside a round chip without the caller having to shrink it, and
 * the stroke scales with the box rather than staying a fixed hairline.
 */
export function IconXMark(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M6 6 18 18M18 6 6 18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    );
}
